import { useEffect, useState } from 'react';
import { setTitle, setFavicon, getContrastColor, getHighlightColor, addHashIfNeeded } from '../utils';

type SetBrandingValuesArgs = {
  primaryColor?: string;
  secondaryColor?: string;
  logo?: string;
  smallLogo?: string;
  appTitle?: string;
  appFavicon?: string;
};

const APP_FAVICON_PATH = 'src/assets/images/favicon/vopay-favicon.svg';
const PRIMARY_COLOR = '#FFD147';
const SECONDARY_COLOR = '#2D2D2D';
const SECONDARY_HIGHLIGHT_COLOR = '#3E3E3E';

export type PortalBranding = {
  primaryColor: string;
  secondaryColor: string;
  logo: string;
  smallLogo: string;
  appTitle: string;
  setBrandingValues: (args: SetBrandingValuesArgs) => void;
};

export default function usePortalBranding(defaultTitle: string): PortalBranding {
  const [primaryColor, setPrimaryColor] = useState(PRIMARY_COLOR);
  const [secondaryColor, setSecondaryColor] = useState(SECONDARY_COLOR);
  const [secondaryHighlight, setSecondaryHighlight] = useState(SECONDARY_HIGHLIGHT_COLOR);
  const [logo, setLogo] = useState('');
  const [smallLogo, setSmallLogo] = useState('');
  const [appTitle, setAppTitle] = useState(defaultTitle);

  useEffect(() => {
    document.documentElement.style.setProperty('--primary-color', primaryColor);
    document.documentElement.style.setProperty('--primaryColor', primaryColor);
    document.documentElement.style.setProperty('--secondary-color', secondaryColor);
    document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
    document.documentElement.style.setProperty('--primary-text-color', getContrastColor(primaryColor));
    document.documentElement.style.setProperty('--primaryTextColor', getContrastColor(primaryColor));
    document.documentElement.style.setProperty('--secondary-text-color', getContrastColor(secondaryColor));
    document.documentElement.style.setProperty('--secondaryTextColor', getContrastColor(secondaryColor));
    document.documentElement.style.setProperty('--secondary-highlight', secondaryHighlight);
    document.documentElement.style.setProperty('--secondaryHighlightColor', secondaryHighlight);
  }, [primaryColor, secondaryColor, secondaryHighlight]);

  function setBrandingValues(args: SetBrandingValuesArgs) {
    if (args.primaryColor) {
      setPrimaryColor(addHashIfNeeded(args.primaryColor));
    } else {
      setPrimaryColor(PRIMARY_COLOR);
    }

    if (args.secondaryColor) {
      setSecondaryColor(addHashIfNeeded(args.secondaryColor));
      setSecondaryHighlight(getHighlightColor(args.secondaryColor));
    } else {
      setSecondaryColor(SECONDARY_COLOR);
      setSecondaryHighlight(SECONDARY_HIGHLIGHT_COLOR);
    }
    setAppTitle(args.appTitle || defaultTitle);
    setTitle(args.appTitle || defaultTitle);
    setFavicon(args.appFavicon || APP_FAVICON_PATH);
    setLogo(args.logo || '');
    setSmallLogo(args.smallLogo || args.logo || '');
  }

  return {
    primaryColor,
    secondaryColor,
    logo,
    smallLogo,
    appTitle,
    setBrandingValues,
  };
}
